import React from 'react';
import { THeadRow } from './DueListTable';

const SKELETON_ROWS = 10;
const COLUMNS = 9;

const SkeletonTable = () => (
    <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
        <style>{`
            @keyframes skeletonPulse {
                0%   { opacity: 0.15; }
                50%  { opacity: 0.30; }
                100% { opacity: 0.15; }
            }
            .skeleton-bar {
                height: 12px;
                border-radius: 4px;
                background-color: #8898aa;
                animation: skeletonPulse 1.4s ease-in-out infinite;
            }
        `}</style>
        <table className="align-items-center table table-flush" style={{ tableLayout: 'fixed' }}>
            <thead className="thead-light">
                <THeadRow />
            </thead>
            <tbody>
                {Array.from({ length: SKELETON_ROWS }, (_, rowIdx) => (
                    <tr key={rowIdx}>
                        {Array.from({ length: COLUMNS }, (_, colIdx) => (
                            <td key={colIdx} className="py-3 px-3">
                                <div
                                    className="skeleton-bar"
                                    style={{
                                        width: `${60 + ((rowIdx + colIdx) % 4) * 10}%`,
                                        animationDelay: `${rowIdx * 0.05}s`,
                                    }}
                                />
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

export default SkeletonTable;
